import React from 'react';
import { FaPlay } from 'react-icons/fa';
import CardItem from '../CardItem/CardItem';
import BaseCarousel from '../BaseCarousel/BaseCarousel';
import './SquareCarousel.css';

const SquareCarousel = ({ title, contents }) => {
    const renderItem = (content, handleClick) => (
        <div
            key={content.contentId}
            className={`square-carousel-item status-${content.status}`}
            onClick={() => handleClick(content)}
            style={{
                cursor: content.status !== 'blocked' ? 'pointer' : 'not-allowed',
                opacity: content.status !== 'blocked' ? 1 : 0.5,
            }}
        >
            <div className="square-carousel-image-container">
                <CardItem
                    status={content.status}
                    imageUrl={content.thumbnailUrl}
                    onClick={() => handleClick(content)}
                />
                <div className="square-carousel-play-icon">
                    <FaPlay className="square-carousel-item-icon" />
                </div>
            </div>
            <div className="square-carousel-content">
                <h3 className="square-carousel-title">{content.title}</h3>
                <p className="square-carousel-subtitle">{content.description}</p>
            </div>
        </div>
    );

    return <BaseCarousel title={title} contents={contents} renderItem={renderItem} />;
};

export default SquareCarousel; 